import { type SurveyCommunicationType, SurveyCommunicationTypeEnum } from '@/models'

export const isEmailType = (type?: SurveyCommunicationType) => {
  return type === SurveyCommunicationTypeEnum.enum.email
}

export const isInAppType = (type?: SurveyCommunicationType) => {
  return type === SurveyCommunicationTypeEnum.enum['in-app']
}

export const isSmsType = (type?: SurveyCommunicationType) => {
  return type === SurveyCommunicationTypeEnum.enum.sms
}
